import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_RED } from "../../config/constants";

const Connector13ARed13CRed = ({ state, workState }) => (
   <g id="Track13Red13CRed-connector" transform="translate(1823.000000, 1146.000000)">
      <g id="line"
         transform="translate(0.000000, 0.933594)"
         stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
         strokeLinecap="round"
      >
         <line
            x1="68" y1="44.0664063" x2="42" y2="0.06640625"
            strokeWidth={tracksWidth}
            strokeLinejoin="round"/>
      </g>
   </g>
);

export default Connector13ARed13CRed;
